// extracted by mini-css-extract-plugin
module.exports = {"LeftSide":"SplitLabel3_LeftSide__NQSp7","Middle":"SplitLabel3_Middle__z1XJG","RightSide":"SplitLabel3_RightSide__1HX3B"};